import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useI18n } from '../i18n/LanguageProvider';

const LanguageSelector = () => {
  const { languages, code, setCode, t } = useI18n();
  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (!dropdownRef.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') {
        setOpen(false);
        setMobileOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, []);

  const select = (next) => {
    setCode(next);
    setOpen(false);
    setMobileOpen(false);
  };

  const current = languages.find((l) => l.code === code) || languages[0];

  return (
    <div className="lang-switch" ref={dropdownRef}>
      <button
        type="button"
        className={`lang-chip ${open ? 'active' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <span className="dot" aria-hidden="true" />
        <span className="label">{(current.short || current.code || '').toUpperCase()}</span>
        <span className="caret" aria-hidden="true">▾</span>
      </button>

      <div className={`lang-dropdown ${open ? 'open' : ''}`} role="listbox">
        {languages.map((lang) => (
          <button
            key={lang.code}
            type="button"
            className={`lang-option ${lang.code === code ? 'selected' : ''}`}
            onClick={() => select(lang.code)}
            role="option"
            aria-selected={lang.code === code}
          >
            <span className="lang-name">{lang.native}</span>
            {lang.code === code && <span className="pill">✓</span>}
          </button>
        ))}
      </div>

      <button
        type="button"
        className="lang-mobile-trigger"
        onClick={() => setMobileOpen(true)}
        aria-label={t('header.language', 'Language')}
      >
        {(current.short || current.code || '').toUpperCase()}
      </button>

      {mobileOpen &&
        createPortal(
          <div className="lang-modal" role="dialog" aria-modal="true" onClick={() => setMobileOpen(false)}>
            <div className="lang-modal__sheet" onClick={(e) => e.stopPropagation()}>
              <div className="lang-modal__head">
                <p style={{ margin: 0, fontWeight: 700 }}>{t('header.language', 'Language')}</p>
                <button className="lang-modal__close" aria-label="Close" onClick={() => setMobileOpen(false)}>
                  ×
                </button>
              </div>
              <div className="lang-modal__list">
                {languages.map((lang) => (
                  <button
                    key={lang.code}
                    type="button"
                    className={`lang-option ${lang.code === code ? 'selected' : ''}`}
                    onClick={() => select(lang.code)}
                  >
                    <span className="lang-name">{lang.native}</span>
                    {lang.code === code && <span className="pill">✓</span>}
                  </button>
                ))}
              </div>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
};

export default LanguageSelector;
